import FileSaver from "file-saver";
import XLSX from "xlsx";
import {export_json_to_excel} from "./Export2Excel";

export function exportData (exportRule,list){
    require.ensure([], () => {
        const { export_json_to_excel } = require('./Export2Excel')
        const data = formatJson(exportRule.bodyFilter, list)
        console.log(data);
        export_json_to_excel(exportRule.excelHeader, data, exportRule.excelName)
    })
}

export function exportData2 (header,data,name){
    require.ensure([], () => {
        export_json_to_excel(header, data, name)
    })
}

function formatTimestamp(timestamp) {
    if(timestamp == null || timestamp == "" || timestamp == undefined){
        return "";
    }
    let date = new Date(timestamp);
    //年份
    let Year = date.getFullYear(); 
    //月份下标是0-11
    let Months = ( date.getMonth() + 1 ) < 10  ?  '0' + (date.getMonth() + 1) : ( date.getMonth() + 1); 
    //具体的天数
    let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    //小时
    let Hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    //分钟
    let Minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    //秒
    let Seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    //返回数据格式
    return Year + '-' + Months + '-' + Day + ' ' + Hours + ':' + Minutes + ':' + Seconds; 
}
function formatDate(str) {
    let date = new Date(str);
    //年份
    let Year = date.getFullYear(); 
    //月份下标是0-11
    let Months = ( date.getMonth() + 1 ) < 10  ?  '0' + (date.getMonth() + 1) : ( date.getMonth() + 1); 
    //具体的天数
    let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    //返回数据格式
    return Year + '-' + Months + '-' + Day; 
}

function formatJson(columns, datas) {
    let data = datas.map(r => columns.map(c => {
        if(c == 'txTime'){
            return formatTimestamp(r[c]*1000);
        }if(c == 'profitAt'){
            return formatDate(r[c]);
        }else{
            return r[c];
        }   
    }));
    return data;
}

export function exportData1 (exportRule){
   /* 从表生成工作簿对象 */
   var wb = XLSX.utils.table_to_book(document.querySelector(exportRule.querySelectorId),{raw: true});
   /* 获取二进制字符串作为输出 */
   var wbout = XLSX.write(wb, {
       bookType: "xlsx",
       bookSST: true,
       type: "array"
   });
   try {
       FileSaver.saveAs(
       //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
       new Blob([wbout], { type: "application/octet-stream" }),
       //设置导出文件名称
       exportRule.excelName
       );
   } catch (e) {
       if (typeof console !== "undefined") console.log(e, wbout);
   }
   return wbout;
}